import z from 'zod';
import { UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBBigIntSchema, DBSha256Schema, DBTimestampSchema, Sha256Schema } from '../common/sql';
import { AssetBucket } from './enums';

/**
 * DB Schemas
 */

export const DBAssetIdSchema = UUIDSchema;
export const DBAssetBucketSchema = z.enum(AssetBucket);
export const DBAssetObjectPathSchema = z.string().min(1).max(1024);
export const DBAssetSha256Schema = DBSha256Schema;
export const DBAssetMimeTypeSchema = z.string().min(1).max(255);
export const DBAssetByteSizeSchema = DBBigIntSchema;
export const DBAssetWidthSchema = z.number().int().positive().nullable();
export const DBAssetHeightSchema = z.number().int().positive().nullable();

export const DBAssetSchema = z.object({
  id: DBAssetIdSchema,
  bucket: DBAssetBucketSchema,
  objectPath: DBAssetObjectPathSchema,
  sha256: DBAssetSha256Schema,
  mimeType: DBAssetMimeTypeSchema,
  byteSize: DBAssetByteSizeSchema,
  width: DBAssetWidthSchema,
  height: DBAssetHeightSchema,
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

/**
 * Client Schemas
 */

export const AssetIdSchema = UUIDSchema;
export const AssetBucketSchema = z.enum(AssetBucket).openapi({
  description: 'Which private Storage bucket holds the object',
  example: AssetBucket.QuestionAssets,
});
export const AssetObjectPathSchema = DBAssetObjectPathSchema;
export const AssetSha256Schema = Sha256Schema;
export const AssetMimeTypeSchema = DBAssetMimeTypeSchema;
export const AssetByteSizeSchema = z.number().int().min(0);
export const AssetWidthSchema = DBAssetWidthSchema;
export const AssetHeightSchema = DBAssetHeightSchema;

export const AssetSchema = z.object({
  id: AssetIdSchema,
  bucket: AssetBucketSchema,
  objectPath: AssetObjectPathSchema,
  sha256: AssetSha256Schema,
  mimeType: AssetMimeTypeSchema,
  byteSize: AssetByteSizeSchema,
  width: AssetWidthSchema,
  height: AssetHeightSchema,
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});
